import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectFullPageRefresh } from './store/storiesReducer'
import { OutboundLink } from 'react-ga'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import { CardMedia } from '@material-ui/core'
import api from './exhibitApi'

import './Ads.css'

// Story is of type 'story'.
// Story can have inline ads or banner ads
// banner ads or inline ads have the isImage property set to false
function FullPageAd({ story, loadContent}) {
  const id = story._id

  const [fullStory, setFullStory] = useState({ assets: [] })
  const [href, setHref] = useState(null)
  const [src, setSrc] = useState(null)
  const refreshAd = useSelector(selectFullPageRefresh)

  useEffect(() => {
    async function getStory (id) {
      if(!id) return

      const data = await api.story().getById(id)
      setFullStory(data)
    }

    if(!loadContent) return
    getStory(id)
  }, [loadContent, id])

  const assetLength = fullStory.assets.filter(a => a.isImage).length

  useEffect(() => {
    if(assetLength > 0) {
      const idx = api.util().getRandomInt(assetLength)
      const asset = fullStory.assets[idx]
      setSrc(api.image().imageUrl(asset.link, 320, 600, window.devicePixelRatio))
      setHref(asset.caption)
    }
  }, [refreshAd, fullStory])

  if(loadContent) {
    return (
      <Card className="ad-container" elevation={0} square={true}>
      <CardContent>
        <div className="ad-wrapper">
        <CardMedia>
          <OutboundLink eventLabel={`Ad Click: ${href}`} to={href}>
                <div className="ad-fullpage--320x600">
                <img src={src} alt="" />
              </div>
          </OutboundLink>
        </CardMedia>
        </div>
      </CardContent>
    </Card>
    )
  }
  else {
    return <Card className="ad-container" elevation={0} square={true}>
        <CardContent><div className="ad-wrapper"></div></CardContent>
      </Card>
  }
}

export default FullPageAd
